/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
	CompanyUniversityAccordDTO,
	CompanyUniversityAccordDTOFromJSON,
	CompanyUniversityAccordDTOFromJSONTyped,
	CompanyUniversityAccordDTOToJSON,
} from "./CompanyUniversityAccordDTO";

/**
 *
 * @export
 * @interface CompanyUniversityAccordDTOPagedResponse
 */
export interface CompanyUniversityAccordDTOPagedResponse {
	/**
	 *
	 * @type {number}
	 * @memberof CompanyUniversityAccordDTOPagedResponse
	 */
	page?: number;
	/**
	 *
	 * @type {number}
	 * @memberof CompanyUniversityAccordDTOPagedResponse
	 */
	pageSize?: number;
	/**
	 *
	 * @type {number}
	 * @memberof CompanyUniversityAccordDTOPagedResponse
	 */
	totalCount?: number;
	/**
	 *
	 * @type {Array<CompanyUniversityAccordDTO>}
	 * @memberof CompanyUniversityAccordDTOPagedResponse
	 */
	data?: Array<CompanyUniversityAccordDTO> | null;
}

export function CompanyUniversityAccordDTOPagedResponseFromJSON(
	json: any
): CompanyUniversityAccordDTOPagedResponse {
	return CompanyUniversityAccordDTOPagedResponseFromJSONTyped(json, false);
}

export function CompanyUniversityAccordDTOPagedResponseFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): CompanyUniversityAccordDTOPagedResponse {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		page: !exists(json, "page") ? undefined : json["page"],
		pageSize: !exists(json, "pageSize") ? undefined : json["pageSize"],
		totalCount: !exists(json, "totalCount") ? undefined : json["totalCount"],
		data: !exists(json, "data")
			? undefined
			: json["data"] === null
			? null
			: (json["data"] as Array<any>).map(CompanyUniversityAccordDTOFromJSON),
	};
}

export function CompanyUniversityAccordDTOPagedResponseToJSON(
	value?: CompanyUniversityAccordDTOPagedResponse | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		page: value.page,
		pageSize: value.pageSize,
		totalCount: value.totalCount,
		data:
			value.data === undefined
				? undefined
				: value.data === null
				? null
				: (value.data as Array<any>).map(CompanyUniversityAccordDTOToJSON),
	};
}
